<template>
  <div>
    <div v-if="title" class="mb-4">
      <div>
        <h5><i class="dot"></i>{{ title }}<span class="ml-1 font-normal" style="font-size: 16px; color: #3c3c3c">{{annotation}}</span></h5>
      </div>
    </div>
    <div class="overflow-x-auto">
      <table class="w-full" style="table-layout: fixed">
        <colgroup><slot name="colgroup"></slot></colgroup>
        <thead><slot name="thead"></slot></thead>
        <tbody v-for="(group, groupIdx) in groups" :key="groupIdx">
          <tr v-if="data[group]">
            <th class="m-0 p-0">
              <group-head :group="group" v-model="data[group].open" :item-count="(data[group].data || []).length" @addItem="addItem"/>
            </th>
            <slot name="group-tr" :group="group" :data="data[group].data"></slot>
          </tr>
          <template v-if="data[group] && data[group].open">
            <tr v-for="(item, item_i) in data[group].data" :key="item_i">
              <td class="m-0 p-0 pl-4" style="background-color: #fafafa;">
                <group-item v-model="item.group" :fixed="item.fixed ? true : false" @removeItem="() => {removeItem(group, item_i)}"/>
              </td>
              <slot name="tr" :group="group" :data="item.data"></slot>
            </tr>
          </template>
        </tbody>
        <tfoot><slot name="tfoot"></slot></tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import GroupHead from "@/components/group-data-table/GroupHead.vue";
import GroupItem from "@/components/group-data-table/GroupItem.vue";

export default {
  name: "GroupDataTable",
  components: {GroupItem, GroupHead},
  props: {
    heads: Array,
    title: String,
    annotation: String,
    groups: Array,
    fixedItems: Object,
    value: Object,
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    toggleOpenAll () {
      const keys = Object.keys(this.data);
      let openAll = false;
      for (const key of keys) {
        if (this.data[key].open) {
          openAll = true;
        }
        this.data[key].open = !this.data[key].open;
      }

      if (openAll) {
        for (const key of keys) {
          this.data[key].open = !openAll;
        }
      }
    },
    addItem(group) {
      this.data[group].open = true;
      this.data[group].data.push({
        group: "",
        data: {},
      });
    },
    removeItem(group, index) {
      this.data[group].data.splice(index, 1);
    }
  },
  created() {
    const data = this.groups.reduce((acc, group) => {
      acc[group] = {
        fixed: false,
        open: false,
        data: [],
      };
      return acc;
    }, {});

    const groups = Object.keys(this.fixedItems);
    if (groups.length > 0) {
      for (const group of groups) {
        for (const item of this.fixedItems[group]) {
          data[group].open = true
          data[group].data.push({
            fixed: true,
            group: item,
            data: {},
          });
        }
      }
    }

    this.$set(this, 'data', data);
  },
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  background: #f9f9f9;

  border-left: solid 1px #cdcdcd;
  border-top: solid 1px #cdcdcd;

  &,
  th,
  td {
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    font-size: 1rem;
  }

  th {
    padding: 0.675rem;
    text-align: center;
    align-items: center;
  }

  td {
    padding: 0.375rem;
    background-color: #fff;
    text-align: right;
  }
}
</style>
